// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YellowCardVehicleWrapper > div {
   background-color: rgb(248, 252, 239);
   padding: 20px 14px;
   border-radius: 8px;
   margin-top: 15px;
   display: grid;
   grid-template-columns: repeat(3, 1fr);
   gap: 25px 20px;
}

.YellowCardVehicleWrapper {
   display: grid;
   grid-template-columns: 95% 5%;
}

.addVehicleInputWrapper {
   display: grid;
   grid-template-columns: repeat(3, 1fr);
   gap: 20px;
}

.addVehicleInputWrapper > div {
   text-align: start;
   margin-bottom: 20px;
}

.VehicledeleteIcon {
   display: flex;
   justify-content: center;
   align-items: center;
   font-size: 20px !important;
   color: rgb(255, 67, 67);
}

.VehicledeleteIcon:hover {
   cursor: pointer;
   color: rgb(233, 0, 0);
}

.imgWrapper {
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   gap: 20px;
   width: 100%;
   margin-top: 20px;
   padding: 10px;
   box-sizing: border-box;
   border-radius: 4px;
   border: 1px solid #ced7ec;
}
.imgWrapper img {
   height: 220px;
   border-radius: 10px;
   width: 100%;
   object-fit: contain;
   padding: 10px;
}
.imgWrapper p {
   font-weight: 600;
   margin-bottom: 2px;
}

/* ----------------------- Media Query ---------------------- */

@media (max-width: 1200px) {
   .YellowCardVehicleWrapper > div {
      grid-template-columns: repeat(2, 1fr);
   }

   .imgWrapper {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
   }
   .imgWrapper img {
      height: 160px;
   }

   .addVehicleInputWrapper {
      grid-template-columns: repeat(2, 1fr);
   }
}

@media (max-width: 900px) {
   .imgWrapper {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
   }
   .imgWrapper img {
      height: 180px;
   }
}
`, "",{"version":3,"sources":["webpack://./src/components/contractorManagement/contractor.css"],"names":[],"mappings":"AAAA;GACG,oCAAoC;GACpC,kBAAkB;GAClB,kBAAkB;GAClB,gBAAgB;GAChB,aAAa;GACb,qCAAqC;GACrC,cAAc;AACjB;;AAEA;GACG,aAAa;GACb,6BAA6B;AAChC;;AAEA;GACG,aAAa;GACb,qCAAqC;GACrC,SAAS;AACZ;;AAEA;GACG,iBAAiB;GACjB,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,uBAAuB;GACvB,mBAAmB;GACnB,0BAA0B;GAC1B,uBAAuB;AAC1B;;AAEA;GACG,eAAe;GACf,qBAAqB;AACxB;;AAEA;GACG,aAAa;GACb,qCAAqC;GACrC,SAAS;GACT,WAAW;GACX,gBAAgB;GAChB,aAAa;GACb,sBAAsB;GACtB,kBAAkB;GAClB,yBAAyB;AAC5B;AACA;GACG,aAAa;GACb,mBAAmB;GACnB,WAAW;GACX,mBAAmB;GACnB,aAAa;AAChB;AACA;GACG,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA,+DAA+D;;AAE/D;GACG;MACG,qCAAqC;GACxC;;GAEA;MACG,aAAa;MACb,qCAAqC;GACxC;GACA;MACG,aAAa;GAChB;;GAEA;MACG,qCAAqC;GACxC;AACH;;AAEA;GACG;MACG,aAAa;MACb,qCAAqC;GACxC;GACA;MACG,aAAa;GAChB;AACH","sourcesContent":[".YellowCardVehicleWrapper > div {\n   background-color: rgb(248, 252, 239);\n   padding: 20px 14px;\n   border-radius: 8px;\n   margin-top: 15px;\n   display: grid;\n   grid-template-columns: repeat(3, 1fr);\n   gap: 25px 20px;\n}\n\n.YellowCardVehicleWrapper {\n   display: grid;\n   grid-template-columns: 95% 5%;\n}\n\n.addVehicleInputWrapper {\n   display: grid;\n   grid-template-columns: repeat(3, 1fr);\n   gap: 20px;\n}\n\n.addVehicleInputWrapper > div {\n   text-align: start;\n   margin-bottom: 20px;\n}\n\n.VehicledeleteIcon {\n   display: flex;\n   justify-content: center;\n   align-items: center;\n   font-size: 20px !important;\n   color: rgb(255, 67, 67);\n}\n\n.VehicledeleteIcon:hover {\n   cursor: pointer;\n   color: rgb(233, 0, 0);\n}\n\n.imgWrapper {\n   display: grid;\n   grid-template-columns: repeat(4, 1fr);\n   gap: 20px;\n   width: 100%;\n   margin-top: 20px;\n   padding: 10px;\n   box-sizing: border-box;\n   border-radius: 4px;\n   border: 1px solid #ced7ec;\n}\n.imgWrapper img {\n   height: 220px;\n   border-radius: 10px;\n   width: 100%;\n   object-fit: contain;\n   padding: 10px;\n}\n.imgWrapper p {\n   font-weight: 600;\n   margin-bottom: 2px;\n}\n\n/* ----------------------- Media Query ---------------------- */\n\n@media (max-width: 1200px) {\n   .YellowCardVehicleWrapper > div {\n      grid-template-columns: repeat(2, 1fr);\n   }\n\n   .imgWrapper {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n   }\n   .imgWrapper img {\n      height: 160px;\n   }\n\n   .addVehicleInputWrapper {\n      grid-template-columns: repeat(2, 1fr);\n   }\n}\n\n@media (max-width: 900px) {\n   .imgWrapper {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n   }\n   .imgWrapper img {\n      height: 180px;\n   }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
